import { Component, Host, h, Prop, State, Element } from '@stencil/core';
import { getIcon, getElementClass, shouldHideMessage, dismissMessage } from './utils.js';

@Component({
  tag: 'spw-message',
  styleUrl: 'spw-message.scss',
  shadow: true,
})
export class SpwMessage {
  @Element() el: HTMLSpwMessageElement;

  /** Le type de variante */
  @Prop() variant: 'default' | 'success' | 'info' | 'alert' | 'warning' = 'default';
  /** Identifiant unique pour le message */
  @Prop() messageId: string;
  /** Si la notification est masquable */
  @Prop() isDismissable: boolean = true;
  /** Texte du bouton pour masquer la notification */
  @Prop() dismissableText: string = 'Masquer';
  /** Titre de la notification */
  @Prop() messageTitle: string = 'Notification';

  @State() isVisible: boolean = true;

  componentWillLoad() {
    this.isVisible = !shouldHideMessage(this.messageId);
  }

  private handleKeyDown = (ev: KeyboardEvent) => {
    if (ev.key === 'Enter') {
      ev.preventDefault();
      this.handleDismiss();
    }
  };

  private handleDismiss = () => {
    dismissMessage(this.messageId, () => {
      this.isVisible = false;
    });
  };

  render() {
    return this.isVisible ? (
      <Host>
        <div class={getElementClass(this.variant)} role="alert" aria-live="polite" aria-label={this.messageTitle}>
          <div class="spw-message__title-container">
            <strong class="spw-message__title">
              <spw-icon icon={getIcon(this.variant)}></spw-icon> {this.messageTitle}
            </strong>
            {this.isDismissable && (
              <spw-link tabindex="0" icon="fa-close" class="spw-message__close" aria-label={this.dismissableText} onClick={this.handleDismiss} onKeyDown={this.handleKeyDown}>
                {this.dismissableText}
              </spw-link>
            )}
          </div>
          <div class="spw-message__text">
            <slot></slot>
          </div>
        </div>
      </Host>
    ) : null;
  }
}
